export default {
    // 模块名称
    historyAlarm: {
        // 按钮类
        button: {
            choose: 'Select',
            Reset: 'Reset',
            Search: 'Query',
            View: 'View',
            close: 'close',      
            confirm: 'Confirm',
            export: 'Export',
            cancel: 'Cancel'
        },
        // 文字标签类
        label: {
            details: 'Details',
            uploadVideo: 'Upload video:',
            no: 'No',
            reportTo: 'Report people:',
            warnDesc: 'Alarm description:',
            relatedDocuments: 'Relevant documents:',
            exeNumber: 'No',
            executive: 'Executive personnel',
            implementation: 'Executive situation',
            executiveAct: 'Executive action：',
            executiveDes: 'Executive described：',
            screening: 'Unfold',
            closeScreening: 'Fold',
            wholeChexk: 'All',
            taskName: 'Task name',
            creatorName: 'Designator',
            taskType: 'Task type',
            status: 'Task status',
            taskPriority: 'Priority',
            taskVisibility: 'Visibility',
            createTime: 'Assign time',
            desc: 'Description',
            modifyTime: 'Actual completion time',
            doDetail: 'Execution details',
            alarmDetail: 'Alarm details',
            doStart: 'Start time',
            doEnd: 'Completion time',
            whole: 'All  ',
            noData: 'No data' ,
            scan: 'Live browsing' ,
            videoPlay: 'Video playback',
            waiting: 'Initialize the controller, please wait...'  ,
            play: 'Play',
            snap: 'Capture',
            full: 'Full',
            playback: 'Playback',
            exporting: 'Exporting'                
        },
        // 提示类
        placeholder: {
            startDate: 'Select start date',
            endDate: 'Select end date'
        },
        // 消息类
        message: {
            unableView: 'Unable to view task details',
            noDeviceInfor: 'No device information for current alarm!',
            noDevicePlan: 'No video plan for equipment!',
            selArea: 'Please select area',
            export30: 'Export data time span cannot exceed 30 days',
            alarmTime: 'The alarm time is not entered. The latest 7 days data is exported by default?'
        },
        // 标题类
        title: {
            alarmDetail: 'Alarm Details',
            SnapshotPreview: 'Snapshot preview',
            alarmName: 'Alarm name:',
            alarmType: 'Alarm type',
            alarmLevel: 'Alarm level',
            alarmTime: 'Alarm time',
            alarmLoca: 'Alarm location:',
            videoPlayback: 'Video playback:',
            dealWith: 'Manage Details',
            Processingpers: 'Manage person:',
            ProcessingDes: 'Manage describe:',
            viewTask: 'View task details',
            taskDetail: 'Task details:',
            resourcesDetail: 'Resources detail:',
            choose: 'Select area:',
            subsystem: 'Subsystem',
            alarmState: 'Processing state',
            area: 'Alarm area',
            deviceName: 'Alarm device',
            alarmArea: 'Area',
            historyAlarm: 'History alarm',
            prompt: 'Propmt'
        }
    }
}